module.exports = __webpack_public_path__ + "/login_ui/img/mo-ba54ad4b8393a2412f0af505da010ed2.svg";